import { OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';
import { ControlledPhoneInput } from './ControlledInputs';

interface Props {
  disabled?: boolean;
  tabIndex?: number;
}
export const PhoneInput = ({ disabled, tabIndex }: Props) => {
  return (
    <ControlledPhoneInput
      name={OnboardingFormFields.PHONE_NUMBER}
      id={OnboardingFormFields.PHONE_NUMBER}
      title={t('pages.phone.phoneFieldTitle')}
      disabled={disabled}
      tabindex={tabIndex}
    />
  );
};
